<template>
  <div class="export-pdf-container">
    <div class="box-header">
      <p class="title">CATEGORY RATING</p>
    </div>
    <div class="content">
      <div class="box-percent">
        <div
          class="item-percent"
          v-for="category in uniCategoryRatings"
          :key="category.id"
        >
          <div class="cate-left">
            <div class="cat-text">
              <p style="">
                {{
                  category.criterion_category
                    ? category.criterion_category.name
                    : ""
                }}
              </p>
            </div>
            <div class="cat-star">
              <p v-if="!category.star || category.star == '0'">
                N/A
              </p>
              <img
                v-else
                :src="
                  `img/icon-rating/${getCategoryStarImg(
                    universityInfo.university_type_id === 1
                      ? 'research'
                      : 'applied',
                    category.star,
                    category.extra
                  )}`
                "
                alt=""
              />
            </div>
          </div>
          <div class="cat-right">
            <div class="box-cat-percent">
              <div
                class="cat-active"
                :class="[
                  {
                    'cat-active-applied':
                      universityInfo.university_type_id === 2
                  }
                ]"
                :style="
                  'width:' + getPercent(category.score, category.weight) + '%'
                "
              ></div>
              <div class="cat-number">{{ category.score | formatNumber }}</div>
              <div class="cat-total">{{ category.weight | formatNumber }}</div>
            </div>
          </div>
        </div>
      </div>
      <p class="text-center">
        <img
          class="last-page-picture category-picture"
          :src="'img/imgPdf/category.png'"
          alt=""
        />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Category",
  props: {
    universityInfo: {},
    uniCategoryRatings: {
      type: Array
    }
  },
  methods: {
    getCategoryStarImg(divisionName, star = "") {
      const displayStar = star && star >= 1 ? parseInt(star) : 1;
      return `${divisionName}_${displayStar}.svg`;
    },
    getPercent(up, down) {
      return (up / down) * 100;
    },
    getPercentRound(up, down) {
      return up / down;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/pdf.scss";

.cat-active-applied {
  background: #008035 !important;
}
</style>
